import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import Swal from "sweetalert2";

import channelUserApi from "../../../../apis/ChannelUser.api";
import {
	setChannelUser,
	setSnsChannelUser,
	setUser,
} from "../../../../redux/store/auth/authDuck";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const NaverCall = () => {
	const history = useHistory();
	// const reduxChannel = useSelector(state => state.channel.reduxChannel);

	const dispatch = useDispatch();
	// const isLoading = useSelector(state => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const clinent_id = "uRBnEup5L0wKh3Onbbtq";
	useEffect(() => {
		const naverLogin = new window.naver.LoginWithNaverId({
			clientId: clinent_id,
			callbackUrl: `${process.env.REACT_APP_HOST}/together/channel/user/sns/naver`,
			callbackHandle: true,
			// isPopup: util.getPlatform !== "Mobile", // 로그인 팝업여부
			loginButton: {
				color: "green", // 색상(white, green)
				type: 3, // 버튼타입(1,2,3)
				height: 60, // 배너 및 버튼 높이
			},
		});

		naverLogin.init();
		naverLogin.logout(); // 네이버 로그인이 계속 유지되는 경우가 있다. 초기화시 로그아웃
		naverLogin.getLoginStatus((status) => {
			if (status) {
				// 필수 제공 동의 조건
				if (naverLogin.user.mobile === undefined) {
					naverLogin.reprompt();
				} else {
					naverLoginSuceess(naverLogin.user);
				}
			} else {
				console.log("Naver 비 로그인 상태");
			}
		});
	}, []);

	const naverLoginSuceess = async (naverUser) => {
		const influencer_id = sessionStorage.getItem("influencer_id");
		const influencer_user_id = sessionStorage.getItem("influencer_user_id");
		const backPage = sessionStorage.getItem("backPage");

		//SNS 가입여부 판단
		let param = {
			provider: "naver",
			provider_id: naverUser.id,
			// influenecer_id: influencer_user_id,
			// phone: naverUser.mobile
			//   ?.replace("-", "")
			//   .replace("-", "")
			//   .replace("+82 ", "0"),
		};
		localStorage.setItem("naverUser", JSON.stringify(naverUser));

		let res = await channelUserApi.snsValid(param);

		if (res.code === 200) {
			const result = res.result;

			//가입 시 로그인 처리
			if (result.is_valid === true) {
				localStorage.removeItem("accessToken");
				localStorage.removeItem("refreshToken");
				localStorage.setItem("accessToken", res.result.tokenDto.accessToken);
				localStorage.setItem("refreshToken", res.result.tokenDto.refreshToken);
				dispatch(setChannelUser(res.result.users));
				// dispatch(setUser(res.result.users));
				setIsLoading(false);

				// setResult(res.data.result);
				// loginLog(res.data.result.user);
				// if (backPage) {
				//     if (guestUserId) {
				//         updateCartUser(res.data.result.user);
				//     }
				// } else {
				//     history.replace("/");
				// }
				const historyParam = {
					id: res.result.users?.id,
					influencer_id: influencer_user_id,
				};
				const historyRes = await channelUserApi.snsLoginHistory(historyParam);

				const userAgent = window.navigator?.userAgent;
				const userAgentData = window.navigator?.userAgentData;
				// const rsp = await axios.get('https://geolocation-db.com/json/');
				// if (rsp.status === 200) {
				const param = {
					user_id: res.result.users?.id ?? 1,
					device_id: userAgent?.replace("Mozilla/5.0", "")?.trim(),
					device_agent: userAgentData?.platform,
					// device_ip: rsp.data.IPv4,
				};
				const rsq = await channelUserApi.postChannelUserIp(param);
				if (rsq.code) {
					if (backPage) {
						history.replace(backPage);
						sessionStorage.removeItem("backPage");
					} else {
						history.replace(`/share/${influencer_id}`);
					}
				}
				console.log("naver welcome", res.result);
			} else {
				if (result.is_user_valid === true) {
					Swal.fire({
						customClass: "alert-custom",
						text: "이미 회원가입이 된 사용자입니다. 아이디 찾기를 진행해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						history.replace(`/together/channel/login?id=${influencer_id}`);
						setIsLoading(false);
					});
				} else {
					let snsUserInfo = {
						provider: "naver",
						provider_id: naverUser.id,
						gender: naverUser.gender,
						phone_number: naverUser.mobile,
						birthday: naverUser.birthday,
						birthyear: naverUser.birthyear,
						profile_nickname: naverUser.nickname,
					};
					dispatch(setSnsChannelUser(snsUserInfo));
					history.push(`/together/channel/sns-signup?id=${influencer_id}`);
					setIsLoading(false);
				}
			}
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "네이버 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				history.replace(`/together/channel/login?id=${influencer_id}`);
				setIsLoading(false);
			});
		}
	};
	return (
		<>
			<div id="naverIdLogin" />
		</>
	);
};
export default NaverCall;
